import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const EyeClosed = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={iconColor}
      strokeWidth="2"
    >
      <title>{iconTitle}</title>
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
};

EyeClosed.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

EyeClosed.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(EyeClosed);
